import { Injectable } from "@angular/core"
import { Observable } from "rxjs";
import { CommonService } from "../Common.service"
import { RestApiService } from "../rest-api.service"
import { ITransmittalTemplateModel, ITransmittalReceiverDetails, ITransmittalDistributionModel, ITransmittalInputModel, ITransmittalInputDetailModel } from 'src/app/ViewModel/TransmittalTemplateModel';

@Injectable({
    providedIn: 'root'
})
export class TransmittalService {
    private endPoints = {
        getProjectMembers: 'ProjectMembersLink/GetMembersAgainstProjectBusinessGroup',
        insertUpdateTransmittalDetails: 'TransmittalTemplate/InsertUpdateTransmittalTemplate',
        insertUpdateTransmittalReceiverDetails: 'TransmittalTemplate/InsertUpdateTransmittalTemplateReceiverDetails',
        insertUpdateTransmittalDistributionDetails: 'TransmittalTemplate/InsertUpdateTransmittalTemplateDistributionDetails',
        getTransmittalDetails: 'TransmittalTemplate/GetTransmittalTemplateDetails',
        getTransmittalReceiverDetails: 'TransmittalTemplate/GetTransmittalTemplateReceiverDetails',
        getTransmittalDistributionDetails: 'TransmittalTemplate/GetTransmittalTemplateDistributionDetails',
        getDocDelayReason :"Transmittal/GetDocumentDRDetails"
    }

    constructor(private restAPIService: RestApiService,private commonService: CommonService){

    }

    public getProjectMembers():Observable<any> {
        let reqData : any ={ projectId : this.commonService.getProjectId()};
        return this.restAPIService.new_POST(this.endPoints.getProjectMembers,reqData);
    }

    public InsertUpdateTransmittalDetails(transmittalDetails: ITransmittalTemplateModel): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.insertUpdateTransmittalDetails, transmittalDetails);
    }

    public InsertUpdateTransmittalReceiverDetails(transmittalReceiverDetails: ITransmittalReceiverDetails): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.insertUpdateTransmittalReceiverDetails, transmittalReceiverDetails);
    }

    public InsertUpdateTransmittalDistributionDetails(transmittalDistributionDetails: ITransmittalDistributionModel): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.insertUpdateTransmittalDistributionDetails, transmittalDistributionDetails);
    }

    public GetTransmittalDetails(transmittalDetails: ITransmittalInputModel): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.getTransmittalDetails, transmittalDetails);
    }

    public GetTransmittalReceiverDetails(transmittalReceiverDetails: ITransmittalInputDetailModel): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.getTransmittalReceiverDetails, transmittalReceiverDetails);
    }

    public GetTransmittalDistributionDetails(transmittalDistributionDetails: ITransmittalInputDetailModel): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.getTransmittalDistributionDetails, transmittalDistributionDetails);
    }
 
    public GetDocDelayReason(messageId: number): Observable<any> {
        let obj={
            "message_Id" : messageId
        }
        return this.restAPIService.new_POST(this.endPoints.getDocDelayReason, obj);
    }

}